import axios from 'axios'
import { API_URL } from './index'
import { REQUEST_USER, RECEIVE_USER, REQUEST_USER_REPORTS, RECEIVE_USER_REPORTS } from '../constants/ActionTypes'

//= ===============================
// Fetch One User Action
//= ===============================

const requestUser = (user_id) => {
	return {
		type: REQUEST_USER,
		user_id
	}
}

const receiveUser = (user_id, response) => {
	return {
		type: RECEIVE_USER,
		user_id,
		payload: response.data,
		receivedAt: Date.now()
	}
}

const fetchUser = (user_id, pageCount) => {
	return dispatch => {
		dispatch(requestUser(user_id))
		let url = `${API_URL}/users/profile/` + user_id
		axios.get(url)
		.then((response) => {
			dispatch(receiveUser(user_id, response))
		})
		.catch((error) => {
			console.log(error)	
		})
	}
}

export const loadUser = (user_id) => (dispatch, getState) => {
	return dispatch(fetchUser(user_id))
}

//= ===============================
// Fetch Multiple User Reports
//= ===============================

const requestUserReports = (user_id, category) => {
	return {
		type: REQUEST_USER_REPORTS,
		user_id,
		category
	}
}

const receiveUserReports = (user_id, category, response) => {
	return {
		type: RECEIVE_USER_REPORTS,
		user_id,
		category,
		payload: response.data,
		receivedAt: Date.now()
	}
}

const fetchUserReports = (user_id, category, pageCount) => {
	return dispatch => {
		dispatch(requestUserReports(user_id, category))
		let url = `${API_URL}/users/profile/` + user_id + `?type=` + category + `&page=` + pageCount + `&limit=5` + `&meta=published`
		axios.get(url)
		.then((response) => {
			dispatch(receiveUserReports(user_id, category, response))
		})
		.catch((error) => {
			console.log(error)	
		})
	}
}

const shouldFetchUserReports = (state, user_id, category) => {
	const reports = state.userById[user_id].reportsByCategory[category]
	if (!reports) {
		return true
	} else if (reports.isFetching) {
		return false
	}
	return true
}

export const loadUserReports = (user_id, category, nextPage) => (dispatch, getState) => {
	const {
		pageCount = 0
	} = getState().userById[user_id].reportsByCategory[category] || {}
	if (pageCount > 0 && !nextPage) {
		return null
	}
	if (shouldFetchUserReports(getState(), user_id, category)) {
		return dispatch(fetchUserReports(user_id, category, pageCount))
	}
}

export const updateUser = (formProps, cb) => {
	return (dispatch, getState) => {
		let url = `${API_URL}/users/profile`
		let data = JSON.stringify({
			name: formProps.name,
			username: formProps.username,
			email: formProps.email,
			headline: formProps.headline,
			profile_picture: formProps.profile_picture,
			Facebook: formProps.Facebook,
			Twitter: formProps.Twitter,
			Youtube: formProps.Youtube,
			Website: formProps.Website
		})
		let token = getState().auth.token
		let authorization = "Bearer " + token
		axios.patch(url, data, {headers:{'Content-Type':'application/json', 'Authorization': authorization}})
		.then((response) => {
			cb()
		})
		.catch((error) => {
			console.log("FAILURE...")
			console.log(error)	
		})
	}
}


// WEBPACK FOOTER //
// ./src/actions/user.js